import { NavLink, Outlet } from "react-router-dom";
import { Globe, Mail } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/admin", label: "Domains", icon: Globe, end: true },
  { to: "/admin/email", label: "Email", icon: Mail, end: false },
];

/**
 * Superadmin-only platform admin area (formerly /settings). Mirrors
 * AccountLayout's sub-nav pattern — each tab is its own route so the
 * Email tab's mutations don't reset when switching away and back.
 */
export function AdminLayout() {
  return (
    <div className="container max-w-3xl py-6">
      <div className="mb-4">
        <h1 className="text-xl font-semibold tracking-tight">Platform admin</h1>
        <p className="text-xs text-muted-foreground mt-0.5">
          Configure the dashboard's domains, HTTPS issuance, and outbound email.
        </p>
      </div>
      <nav className="of-tabstrip -mt-1 mb-5">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              cn(
                "inline-flex shrink-0 items-center gap-1.5 h-9 px-2.5 text-sm whitespace-nowrap text-muted-foreground border-b-2 border-transparent hover:text-foreground transition-colors",
                isActive && "text-foreground border-[rgb(var(--of-fg-default))] font-semibold",
              )
            }
          >
            <t.icon className="h-3.5 w-3.5" />
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
